(function () {
  function initNav(root) {
    if (!root || root.dataset.mjnInitialized === 'true') return;
    root.dataset.mjnInitialized = 'true';

    var strip = root.querySelector('[data-mjn-scroll]');
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('[data-mjn-tab]')
    );
    var prev = root.querySelector('[data-mjn-prev]');
    var next = root.querySelector('[data-mjn-next]');
    var offset =
      parseInt(root.getAttribute('data-scroll-offset'), 10) || 0;

    if (!strip || !tabs.length) return;

    function targetEl(tab) {
      var id = tab.getAttribute('data-target');
      return id ? document.getElementById(id) : null;
    }

    function setActive(tab) {
      tabs.forEach(function (item) {
        var isActive = item === tab;

        item.classList.toggle('mjn__tab--active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      if (!tab) return;

      var tabRect = tab.getBoundingClientRect();
      var stripRect = strip.getBoundingClientRect();

      if (
        tabRect.left < stripRect.left ||
        tabRect.right > stripRect.right
      ) {
        tab.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }

    function updateChevrons() {
      var overflow = strip.scrollWidth - strip.clientWidth > 1;
      var atStart = strip.scrollLeft <= 1;
      var atEnd =
        strip.scrollLeft + strip.clientWidth >=
        strip.scrollWidth - 1;

      if (prev) {
        prev.hidden = !overflow || atStart;
      }

      if (next) {
        next.hidden = !overflow || atEnd;
      }
    }

    tabs.forEach(function (tab) {
      var target = targetEl(tab);

      if (!target) {
        console.warn(
          '[mobile-nav] No section found with id "' +
            tab.getAttribute('data-target') +
            '"'
        );
      }

      tab.addEventListener('click', function () {
        var el = targetEl(tab);

        setActive(tab);

        if (!el) return;

        var targetPosition =
          el.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      });
    });

    if (next) {
      next.addEventListener('click', function () {
        strip.scrollBy({
          left: strip.clientWidth * 0.7,
          behavior: 'smooth'
        });
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        strip.scrollBy({
          left: -strip.clientWidth * 0.7,
          behavior: 'smooth'
        });
      });
    }

    strip.addEventListener('scroll', updateChevrons, {
      passive: true
    });

    window.addEventListener('resize', updateChevrons);

    // Page load par hamesha first tab active hoga.
    setActive(tabs[0]);
    updateChevrons();
  }

  function initAll() {
    document.querySelectorAll('.mjn').forEach(function (root) {
      initNav(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches('.mjn')
      ? event.target
      : event.target.querySelector('.mjn');

    if (root) initNav(root);
  });
})();